<template>
  <div>
    <div class="col-md-12 card text-left">
      <div class="card-header"></div>
      <div class="report-filters">
        <!-- Simple Search -->
        <div class="col-md-3 col-sm-6 col-xs-12 form-group pull-left">
          <el-input
            v-model="search"
            placeholder="Cauta..."
            clearable
            @keyup.enter.native="getData(null)"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div class="search-button-reports form-group pull-left">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="getData(null)">
            <i class="ti-search"></i>
          </div>
        </div>
      </div>
      
      <div class="card-content total-pagination pad-15 wallet-report-table-wrap">

          <!-- :pagination-props="paginationProps" -->
          <!--  -->
        <data-tables-server
          @query-change="paginationChanged"
          v-loading="loading"
          :data="tableData"
          :search-def="{ show: false }"
          :total="total"
          :table-props="tableOptions"
          style="width: 100%;"
        >
          <el-table-column prop="id" :label="$t('reports.wallet_id')" width="70" sortable="custom"></el-table-column>
          <el-table-column prop="firstname" :label="$t('reports.wallet_firstname')" min-width="110" sortable="custom"></el-table-column>
          <el-table-column prop="lastname" :label="$t('reports.wallet_lastname')" min-width="95" sortable="custom"></el-table-column>
          <el-table-column
            prop="email"
            class-name="wallet-ellipsis-cell"
            :label="$t('reports.wallet_email')"
            min-width="220"
            show-overflow-tooltip
            sortable="custom"
          ></el-table-column>
          <el-table-column prop="phone" :label="$t('reports.wallet_phone')" min-width="130" sortable="custom"></el-table-column>
          <el-table-column prop="loyalty_points" :label="$t('reports.wallet_loyalty_points')" min-width="180" sortable="custom"></el-table-column>
          <el-table-column prop="donation_points" :label="$t('reports.wallet_donation_points')" min-width="180" sortable="custom"></el-table-column>
          <el-table-column prop="wallet_value" :label="$t('reports.wallet_value')" min-width="120" sortable="custom">
            <template slot-scope="props">
              {{ parseFloat(props.row.wallet_value || 0).toFixed(2) }} {{ currency }}
            </template>
          </el-table-column>
          <el-table-column prop="driver_wallet" :label="$t('reports.wallet_driver_wallet')" min-width="180" sortable="custom">
            <template slot-scope="props">
              {{ parseFloat(props.row.driver_wallet || 0).toFixed(2) }} {{ currency }}
            </template>
          </el-table-column>
        </data-tables-server>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      search: '',
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      tableData: [],
      total: 0,
      sortBy: 'id',
      sortOrder: 'asc',
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      tableOptions: {
        style: 'width: 100%',
        defaultSort: {
          prop: 'id',
          order: 'ascending'
        }
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    paginationChanged (query) {
      if (query.type === 'page' || query.type === 'size') {
        this.getData(query)
      }
      if (query.type === 'sort') {
        if (query.sort.order) {
          this.sortBy = query.sort.prop
          this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc'
        } else {
          this.sortBy = 'id'
          this.sortOrder = 'asc'
        }
        this.getData(query)
      }
    },
    getData (query) {
      let sortField = this.sortBy
      let sortType = this.sortOrder
      let pageSize = 20
      let page = 1

      if (query) {
        if (query.sort && query.sort.prop) {
          sortField = query.sort.prop
        }
        if (query.sort && query.sort.order) {
          sortType = query.sort.order === 'descending' ? 'desc' : 'asc'
        }
        if (query.pageSize) {
          pageSize = query.pageSize
        }
        if (query.page) {
          page = query.page
        }
      }

      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        search: this.search,
        field: sortField,
        order: sortType
      }

      this.loading = true
      this.apiRequest('/reports/wallet-report?page=' + page + '&pageSize=' + pageSize, 'GET', data, response => {
        if (response.status === true) {
          this.tableData = response.data.items
          this.total = response.data.total
        }
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.wallet-report-table-wrap >>> .el-table {
  width: 100% !important;
}

.wallet-report-table-wrap >>> .el-table thead th > .cell {
  flex-wrap: nowrap;
  white-space: nowrap;
}

.wallet-report-table-wrap >>> .el-table thead th > .cell > span:first-child {
  white-space: nowrap;
}

.wallet-report-table-wrap >>> .el-table thead th .caret-wrapper {
  flex-shrink: 0;
}

.wallet-report-table-wrap >>> .wallet-ellipsis-cell .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Wallet.vue